import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const DiscordServices: React.FC = () => <PlatformServicePage platform="discord" />;
export default DiscordServices;
